import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

export const SortableHeader = ({
    column = {
        id: '',
        key: 'Key',
        label: 'Label',
        append: undefined,
        className: undefined,
    },
    sort,
    onPress,
    style,
}) => {
    column.id = column.id || column.label.toLowerCase();
    const isAsc = sort.direction === 'asc';
    const isSorted = sort.column === column.id;
    return (
        <th
            className={column.className}
            style={style}
            onClick={() =>
                onPress({
                    column: column.id,
                    direction: isSorted ? (isAsc ? 'desc' : 'asc') : 'asc',
                })
            }
        >
            {column.label}
            {column.append && <>&nbsp;{column.append}</>}
            {isSorted && (
                <>
                    &nbsp;
                    <FontAwesomeIcon
                        icon={isAsc ? faChevronDown : faChevronUp}
                        className='icon'
                    />
                </>
            )}
        </th>
    );
};
